import { render, staticRenderFns } from "./ModulesCreateModal.vue?vue&type=template&id=d7564d92&scoped=true"
import script from "./ModulesCreateModal.vue?vue&type=script&lang=js"
export * from "./ModulesCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7564d92",
  null
  
)

export default component.exports